import { Box } from "@chakra-ui/react";

const TableAction = () => {
    return (
        <Box></Box>
    );
}
 
export default TableAction;